// CD-5483: the currency notes of the pop-ups that take evaluator amounts, in the ticket's wording (the advance payment
// note in its own, as those pop-ups are not in the ticket's list) - each pop-up's Currency rows show one as their info
// tooltip (tooltipText).
const CurrencyNoteTextsEnum = {
  // The client invoice bulk edit panels (legacy and third-party), which take client billing and evaluator amounts.
  InvoiceBulkEdit:
    'Currency note:\n' +
    '• Client Billing amounts must be entered in the invoice currency shown above.\n' +
    '• Evaluator Payment amounts must be entered in the currency shown above, the evaluator payment currency (based on ' +
    'the country of their address) - this may be a different currency than the invoice or entered to the report itself.',
  // The evaluator payment edit pop-ups (legacy and third-party) and the Evaluator Payment page of the Edit Assignment
  // pop-up.
  EvaluatorPaymentEdit:
    'Currency note: Enter these amounts in the currency shown above, the evaluator payment currency, based on the ' +
    'country of their address. This may be a different currency than entered to the report itself.',
  // The advance payment pop-ups (legacy and third-party), whose currency is picked on the pop-up itself.
  AdvancePayment:
    'Currency note: Enter the amounts in the currency selected above. They are saved in that currency as entered, ' +
    'without conversion.',
} as const;

export default CurrencyNoteTextsEnum;
